import * as Yup from "yup";
import { cepRequired, email, phone } from "../YupSchema";

export const validationEditUser = Yup.object().shape({
  cell_phone: phone,
  address: Yup.object().shape({
    cep: cepRequired,
    city: Yup.string().required("global.schemas.city.required"),
    state: Yup.string().required("global.schemas.state.required"),
    additional_details: Yup.string().nullable(),
    country: Yup.string().required("global.schemas.country.required"),
    number: Yup.string().required("global.schemas.number_cep.required"),
    street: Yup.string().required("global.schemas.street.required"),
    neighborhood: Yup.string().required("global.schemas.neighborhood.required"),
  }),
  secondary_emails: Yup.array().of(
    Yup.object().shape({
      email: email,
    })
  ),
});
